import * as React from 'react';
import { Header1, InlineText3 } from '@cian/ui-kit';

import { CalltrackingBadge } from './components/CalltrackingBadge';
import * as styles from './Phone.css';

export interface IPhoneProps {
  phone: string;
  siteBlockId?: number | null;
}

export function Phone({ phone, siteBlockId }: IPhoneProps) {
  const isDynamicCalltracking = !!siteBlockId;

  return (
    <div>
      <Header1 as="span">{phone}</Header1>
      {isDynamicCalltracking && (
        <div className={styles['badge']}>
          <CalltrackingBadge />
        </div>
      )}
      <div className={styles['description']}>
        <InlineText3 color="gray60_100">Пожалуйста, скажите, что нашли это объявление на ЦИАН.</InlineText3>
      </div>
    </div>
  );
}
